import Image from "next/image"
import { FunctionComponent } from "react"
import "./style.css"
import Link from "next/link"

interface AnimatedCardProps {
  bgImage?: string
  titleImage?: string
  characterImage?: string
  redirectUrl: string
}

const AnimatedCard: FunctionComponent<AnimatedCardProps> = ({
  bgImage,
  titleImage,
  characterImage,
  redirectUrl,
}) => {
  return (
    <Link
      href={redirectUrl}
      className="txt-compact-xlarge-plus hover:text-ui-fg-base uppercase"
      data-testid="nav-store-link"
    >
      <div className="animated-card">
        <div className="wrapper h-full">
          {bgImage && (
            <Image src={bgImage} alt={"bg"} fill className="cover-image" />
          )}
        </div>
        {titleImage && (
          <Image
            src={titleImage}
            alt={"title"}
            width={88}
            height={0}
            className="animated-card-title"
          />
        )}
        {characterImage && (
          <Image
            src={characterImage}
            alt={"character"}
            fill
            className="animated-character"
          />
        )}
      </div>
    </Link>
  )
}

export default AnimatedCard
